import { apiCall } from "./servicesCall";

export const EXCHANGE_SERVICES = {
  list(data) {
    return apiCall("/exchange/list", data);
  },
  symbolList(data) {
    return apiCall("/exchange/symbol/list", data);
  },
  stockNo(data) {
    return apiCall("/exchange/stock/no", data);
  },
  stockSave(data) {
    return apiCall("/exchange/stock/save", data);
  },
  stockRemove(data) {
    return apiCall("/exchange/stock/remove", data);
  },
  stockPrimary(data) {
    return apiCall("/exchange/stock/primary", data);
  },
  stockLive(data) {
    return apiCall("/exchange/stock/live", data);
  },
  stockChart(data) {
    return apiCall("/exchange/stock/chart", data);
  },
  stockOverview(data) {
    return apiCall("/exchange/stock/overview", data);
  },
};
